/**
 *  Summary :
 *  targetPos - it can be set to the custom tween position or tween position from the store.(by default set to 0)
 *  tagetControl - it can be set to the custom tween rotation or tween rotation from the store.(by default set to 0)
 *  .onStart() - it is a chain function. Multiple animation can be added inside these function
 *  .onUpdate() - it updates target controls on each frame
 */

import { useEffect, useRef } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import * as THREE from 'three'

function Tween(props) {
  const { camera } = useThree()
  let targetPos = new THREE.Vector3(0, 0, 0)
  let targetControl = new THREE.Vector3(0, 0, 0)

  const t1 = useRef(true)
  const t2 = useRef(true)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    targetPos = new THREE.Vector3(
      props.tweenPoint.position[0],
      props.tweenPoint.position[1],
      props.tweenPoint.position[2]
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    targetControl = new THREE.Vector3(
      props.tweenPoint.control[0],
      props.tweenPoint.control[1],
      props.tweenPoint.control[2]
    )
    t1.current = false
    t2.current = false

    let tween = new TWEEN.Tween(camera.position)
      .to(targetPos, props.tweenDuration)
      .easing(props.tweenInterpolation)
      .onStart(function () {
        new TWEEN.Tween(props.controls.current.target)
          .to(targetControl, props.tweenDuration - 100)
          .easing(props.tweenInterpolation)
          .onUpdate(function (d) {
            props.controls.current.update()
          })
          .onComplete(function () {
            t1.current = true
            if (t2.current) {
              props.tweenFinished()
            }
          })
          .start()
      })
      .onComplete(function () {
        t2.current = true
        if (t1.current) {
          props.tweenFinished()
        }
      })
      .start()
    return () => {
      tween.stop()
    }
  }, [
    props.tweenPoint,
    props.controls,
    props.customTweenPoint,
    props.customControlLookat,
    props.isCustomTween,
    props.tweenInterpolation,
    props.tweenDelay,
  ])

  useFrame(() => {
    if (!t1.current || !t2.current) {
      TWEEN.update()
    }
  })
  return null
}

export default Tween
